// import {ReactComponent as Dashboard} from "../assets/images/dashboard.svg";
// import {ReactComponent as BlackDashboard} from "../assets/images/blackDash.svg";
// import {ReactComponent as AccountSetting} from "../assets/images/AccountSetting.svg";
// import {ReactComponent as AccountSetting} from "../assets/images/settingSmall.svg";
// import {ReactComponent as BlackccountSetting} from "../assets/images/settingSmallWhite.svg";

export const hrModule = [
  // {name: "Dashboard",to:"../dashboard",icon:Dashboard,inactiveIcon:BlackDashboard},
  {
    name: "HR Module",
    innerModule: [
      {
        name: "Employees",
        innerModule: [
          {
            name: "Employee List",
            to: "manageStaff",
            permission: "employee",
            isView: "isView",
          },
          {
            name: "Profile Changes",
            to: "profileChanges",
            permission: "employee",
            isView: "isView",
          },
        ]
      },
      {
        name: "Attendance",
        to: "attendance",
        permission: "attendance",
        isView: "isView",
      },
      {
        name: "Deduction",
        to: "deduction",
        permission: "deduction",
        isView: "isView",
      },
      { name: "Loan", to: "loan", permission: "loan", isView: "isView" },
      // {name: "Pension",to:"pension",permission:"pension",isView:"isView"},
      {
        name: "Leave Management",
        to: "leaveManagement",
        permission: "leave",
        isView: "isView",
      },
      {
        name: "Commission",
        to: "commisson",
        permission: "commisson",
        isView: "isView",
      },
      {
        name: "Travel Claims",
        to: "travelAllowances",
        permission: "travelAllowances",
        isView: "isView",
      },
      {
        name: "Recruitment",
        to: "recruitment",
        permission: "recruitment",
        isView: "isView",
      },
      {
        name: "Timesheet",
        to: "timesheet",
        permission: "timesheet",
        isView: "isView",
      },
      {
        name: "Projects",
        to: "Projects",
        permission: "Projects",
        isView: "isView",
      },
      {
        name: "Payroll Module",
        to: "payrollModule",
        permission: "payroll",
        isView: "isView",
      },
      {
        name: "Salary Management",
        to: "salaryEmployeePage",
        permission: "salary",
        isView: "isView",
      },
      {
        name: "Reports",
        to: "reports",
        permission: "reports",
        isView: "isView",
      },
    ],
  },
  // {name: "Accounting Module",
  //   innerModule:[{name: "Items",to:"items"},
  //   ],
  // },
  // {name: "Account Settings",to:"./accountSettings",icon:BlackAccountSetting,inactiveIcon:AccountSetting},
  // {name: "Project",to:"Projects",permission:"project",icon:Dashboard,inactiveIcon:BlackDashboard},
];
export const accountingModule = [
  {
    name: "Accounting Module",
    innerModule: [
      // { name: "Staff", to: "staff", isView: "isView" },
      { name: "Bank Account", to: "bankHome", permission: "bank", isView: "isView" },
      { name: "Inventory", to: "items", permission: "item", isView: "isView" },
      {
        name: "Sales",
        innerModule: [
          { name: "Customer", to: "customer", permission: "", isView: "isView" },
          { name: "Quotes", to: "quotes", permission: "", isView: "isView" },
          { name: "Sales Order", to: "salesHome", permission: "", isView: "isView" },
          { name: "Invoices", to: "invoice", permission: "", isView: "isView" },
          { name: "Credit Notes", to: "notesHome", permission: "", isView: "isView" },
        ]
      },
      {
        name: "Purchases",
        innerModule: [
          { name: "Supplier", to: "supplier", permission: "", isView: "isView" },
          { name: "Bills", to: "createBill", permission: "", isView: "isView" },
          { name: "Purchase Order", to: "purchaseOrder", permission: "", isView: "isView" },
        ]
      },
      // { name: "Expenses", to: "expense", permission: "", isView: "isView" },
      // { name: "Other Income", to: "otherIncome", permission: "", isView: "isView" },
      // { name: "Profit & Loss  Statement", to: "profit&LossStatement", permission: "", isView: "isView" },
      // { name: "Statement Generate", to: "statementGenerate", isView: "isView" },
      // { name: "Cash Flow Statement", to: "cashFlowStatement", isView: "isView" },
    ],
  },
];

export const superAdmin = [
  {
    name: "Super Admin",
    innerModule: [
      { name: "Control Centre", to: "ControlCentre", permission: "", isView: "isView" },
      { name: "Owner Dashboard", to: "userManagement", permission: "", isView: "isView" },
      { name: "Plan Management", to: "planManagement", permission: "", isView: "isView" },
      { name: "Sub Admin", to: "sub-admin", permission: "", isView: "isView" },
      { name: "Communication Center", to: "communicationCenter", permission: "", isView: "isView" },
      { name: "Notification Broadcast", to: "notificationBroadcast", permission: "", isView: "isView" },
      { name: "Fringe Benefits", to: "Fringe", permission: "", isView: "isView" },
      // { name: "Pension", to: "Pensionfild", permission: "", isView: "isView" },
      // { name: "Leaves", to: "Leave", permission: "", isView: "isView" },
      // { name: "Tax Tables", to: "TaxTable", permission: "", isView: "isView" },
      // { name: "UIF", to: "Uif", permission: "", isView: "isView" },
      // { name: "SDL", to: "SDL", permission: "", isView: "isView" },
      { name: "Contributions", to: "Contribution", permission: "", isView: "isView" },
      // { name: "Credits", to: "Credits", permission: "", isView: "isView" },
    ],
  },
];
